import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import PrivacyPolicy from '@src/pages/PrivacyPolicy';

export const Route = createFileRoute('/privacy-policy')({
  head: () => buildSeoHead({ path: '/privacy-policy', ...ROUTE_META['/privacy-policy'] }),
  component: PrivacyPolicyPageWithLayout,
});

function PrivacyPolicyPageWithLayout() {
  return (
    <DefaultLayout>
      <PrivacyPolicy />
    </DefaultLayout>
  );
}
